// DMV-specific chart data for the dashboard
// This data is specifically tailored to match the DMV (DC, Maryland, Virginia) region
// shown in the map view

// Generate dates for the last 7 days
const generateDates = () => {
  const dates = [];
  for (let i = 6; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }));
  }
  return dates;
};

// Crop Health Data for DMV region
export const dmvCropHealthData = {
  labels: ['Montgomery County', 'Fairfax County', 'Prince George\'s County', 'Loudoun County', 'Howard County'],
  datasets: [
    {
      label: 'Crop Health Index',
      data: [92, 87, 79, 90, 85],
      backgroundColor: [
        'rgba(76, 175, 80, 0.8)',
        'rgba(76, 175, 80, 0.8)',
        'rgba(255, 193, 7, 0.8)',
        'rgba(76, 175, 80, 0.8)',
        'rgba(76, 175, 80, 0.8)',
      ],
      borderColor: [
        'rgba(76, 175, 80, 1)',
        'rgba(76, 175, 80, 1)',
        'rgba(255, 193, 7, 1)',
        'rgba(76, 175, 80, 1)',
        'rgba(76, 175, 80, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

// Moisture Trend Data for DMV region
export const dmvMoistureTrendData = {
  labels: generateDates(),
  datasets: [
    {
      label: 'Montgomery County',
      data: [68, 70, 73, 75, 72, 69, 67],
      borderColor: 'rgba(33, 150, 243, 1)',
      backgroundColor: 'rgba(33, 150, 243, 0.1)',
      fill: true,
      tension: 0.4,
    },
    {
      label: 'Fairfax County',
      data: [58, 55, 52, 50, 48, 45, 43],
      borderColor: 'rgba(255, 152, 0, 1)',
      backgroundColor: 'rgba(255, 152, 0, 0.1)',
      fill: true,
      tension: 0.4,
    },
  ],
};

// Crop Distribution Data for DMV region
export const dmvCropDistributionData = {
  labels: ['Corn', 'Soybeans', 'Hay', 'Wheat', 'Vegetables'],
  datasets: [
    {
      data: [38, 30, 15, 12, 5],
      backgroundColor: [
        'rgba(255, 193, 7, 0.8)',
        'rgba(76, 175, 80, 0.8)',
        'rgba(156, 39, 176, 0.8)',
        'rgba(33, 150, 243, 0.8)',
        'rgba(244, 67, 54, 0.8)',
      ],
      borderColor: [
        'rgba(255, 193, 7, 1)',
        'rgba(76, 175, 80, 1)',
        'rgba(156, 39, 176, 1)',
        'rgba(33, 150, 243, 1)',
        'rgba(244, 67, 54, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

// Weather Radar Data for DMV region
export const dmvWeatherRadarData = {
  labels: ['Temperature', 'Humidity', 'Wind Speed', 'Precipitation', 'Sunlight', 'Soil Moisture'],
  datasets: [
    {
      label: 'Current Conditions',
      data: [75, 68, 35, 40, 80, 65],
      backgroundColor: 'rgba(33, 150, 243, 0.2)',
      borderColor: 'rgba(33, 150, 243, 1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(33, 150, 243, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(33, 150, 243, 1)',
    },
    {
      label: 'Optimal Conditions',
      data: [72, 65, 45, 50, 75, 70],
      backgroundColor: 'rgba(76, 175, 80, 0.2)',
      borderColor: 'rgba(76, 175, 80, 1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(76, 175, 80, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(76, 175, 80, 1)',
    },
  ],
};

// Yield Prediction Data for DMV region
export const dmvYieldPredictionData = {
  labels: ['Corn', 'Soybeans', 'Wheat'],
  datasets: [
    {
      label: 'Current Yield Prediction (tons/acre)',
      data: [4.2, 2.8, 2.5],
      backgroundColor: 'rgba(33, 150, 243, 0.8)',
      borderColor: 'rgba(33, 150, 243, 1)',
      borderWidth: 1,
    },
    {
      label: 'Previous Year (tons/acre)',
      data: [3.9, 2.6, 2.3],
      backgroundColor: 'rgba(156, 39, 176, 0.8)',
      borderColor: 'rgba(156, 39, 176, 1)',
      borderWidth: 1,
    },
  ],
}; 